import React from 'react'
import { MuiTypography, MuiGrid, MuiInfoIcon, MuiDialogActions, MuiDialogContent, MuiDialogTitle, MuiButton, MuiDialog, MuiDivider, MuiDialogContentText, muiWithStyles } from '../../ui/MaterialUIComponents';
import theme from '../../../assests/theme'

function ConfirmDeleteDialog(props) {


    const { classes, i18n } = props;
    return (
        <MuiDialog
            open={props.open}
            onClose={() => props.cancel()}

        >

            <MuiDialogTitle style={{ background: theme.palette.grey.dark }} >
                <MuiGrid container>
                    <MuiGrid item xs container alignItems="center" justify="center" >
                        <MuiTypography style={{ fontFamily: "Arial", fontSize: '15px', color: "white" }}>
                            {i18n.commonTexts.delete + ' ' + i18n.commonTexts.school} - {props.name}
                        </MuiTypography>
                    </MuiGrid>

                    <MuiGrid item container alignItems="center" justify="center" xs={1} >
                        <MuiButton >
                            <MuiInfoIcon style={{ color: "white" }} size="small" />
                        </MuiButton>
                    </MuiGrid>
                </MuiGrid>
            </MuiDialogTitle>
            <MuiDialogContent>
                <MuiGrid container xs={12} alignContent="center" justify="center">
                    <MuiTypography variant={theme.typographyStyles.H6} >
                        {i18n.dashBoard.deleteSchoolText}</MuiTypography>
                </MuiGrid>
            </MuiDialogContent>

            <MuiDialogActions>
                <MuiGrid container spacing={2} align="center" justify='flex-end'>

                    <MuiGrid item >
                        <MuiButton

                            style={theme.secondaryButtonStyle}
                            onClick={
                                props.cancel
                            }>
                            {i18n.commonTexts.cancel}
                        </MuiButton>
                    </MuiGrid>
                    <MuiGrid item  >
                        <MuiButton

                            style={theme.primaryButtonStyle}
                            onClick={props.onClickDelete}
                        >
                            {i18n.commonTexts.delete}
                        </MuiButton>
                    </MuiGrid>

                </MuiGrid>
            </MuiDialogActions>

        </MuiDialog>


    )


}
const elementClassNames = theme => ({

    deleteButton: {
        width: "117px",
        borderRadius: "30px",
        textTransform: "none",
        backgroundColor: theme.palette.primary, color: theme.palette.textPrimary,
        [theme.breakpoints.down('xs')]: { width: "150px" }
    },

    cancelButton: {
        width: "117px",
        borderRadius: "30px",
        textTransform: "none",
        border: `1px solid ${theme.palette.secondary[300]}`,
        [theme.breakpoints.down('xs')]: { width: "150px" }
    },
    dialogActionGrid: { height: "5vh" },

})
export default muiWithStyles(elementClassNames)(ConfirmDeleteDialog);